import { addItemToArray, reorderListItems } from './lists'

export const immutableRemoveItemfromArray = (array, element) => {
    const index = array.indexOf(element)
    
    if(-1 === index) {
        return array
    } else {
        return array.splice(index, 1);
    }
}

export const immutableAddItemToArray = (array, element) => addItemToArray(array, element)

export const immutableReorderListItems = (list, oldIndex, newIndex)  => reorderListItems(list, oldIndex, newIndex)